import { Endpoints } from 'utils/paths';
import { ZmyleErrorId } from 'utils/constants';
import { clientApi } from '../api';

interface ErrorWhitelistResponse {
  errorWhitelist: ZmyleErrorId[];
}

export const getErrorsWhitelist = async (): Promise<ErrorWhitelistResponse> => {
  const response = await clientApi.get<ErrorWhitelistResponse>(
    Endpoints.ERRORS_WHITELIST,
  );

  return response.data;
};
